export default "__VITE_ASSET__DpK9okzs__"